import * as validator from 'validator'

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg']

type ValidationResult = {
  state: 'empty' | 'invalid' | 'valid-url' | 'valid-image' | 'valid-base64'
  url: string
}

const isBase64Image = (url: string): boolean => {
  const base64Regex = /^data:image\/(jpeg|jpg|png|gif|webp|svg\+xml);base64,/
  return base64Regex.test(url)
}

const isImageUrl = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url)
    const extension = parsedUrl.pathname.split('.').pop()?.toLowerCase()
    return extension ? IMAGE_EXTENSIONS.includes(extension) : false
  } catch {
    return false
  }
}

export const validateImageUrl = (url: string): ValidationResult => {
  if (!url) {
    return { state: 'empty', url: '' }
  }

  if (isBase64Image(url)) {
    return { state: 'valid-base64', url }
  }

  if (!validator.isURL(url)) {
    return { state: 'invalid', url }
  }

  if (!isImageUrl(url)) {
    return { state: 'valid-url', url }
  }

  return { state: 'valid-image', url }
}
